export * from './address.component';


// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/address/index.ts